module.exports = __webpack_public_path__ + "media/application/images/section_images/services-old-7c7e48923956a35882aa8fa3fca8eff7.jpg";